module.exports = __webpack_public_path__ + "static/media/importV2.5cbaf807.svg";